export function loadTeamMemberList(query) {
  return {
    type: 'LOAD_TEAM_MEMBER_LIST',
    query,
    willReload: !!query,
  };
}

export function loadTeamMemberListCompletion(error, list) {
  return {
    type: 'LOAD_TEAM_MEMBER_LIST_COMPLETION',
    error,
    list,
  };
}

export function resetLoadTeamMemberList(input) {
  return {
    type: 'RESET_LOAD_TEAM_MEMBER_LIST',
    input,
  };
}

export function loadTeamMemberDetail(uid, time) {
  return {
    type: 'LOAD_TEAM_MEMBER_DETAIL',
    uid,
    time,
  };
}

export function loadTeamMemberDetailCompletion(uid, error, data) {
  return {
    type: 'LOAD_TEAM_MEMBER_DETAIL_COMPLETION',
    uid,
    error,
    data,
  };
}
